import { createContext, useContext, useState, ReactNode } from 'react'

type ModalRegistryContextType = {
  isAnyModalOpen: boolean
  openModal: () => void
  closeModal: () => void
}

const ModalRegistryContext = createContext<ModalRegistryContextType | undefined>(undefined)

export function ModalRegistryProvider({ children }: { children: ReactNode }) {
  const [openModalCount, setOpenModalCount] = useState(0)

  const openModal = () => {
    setOpenModalCount(prev => prev + 1)
  }

  const closeModal = () => {
    setOpenModalCount(prev => Math.max(0, prev - 1))
  }

  const isAnyModalOpen = openModalCount > 0

  return (
    <ModalRegistryContext.Provider value={{ isAnyModalOpen, openModal, closeModal }}>
      {children}
    </ModalRegistryContext.Provider>
  )
}

export function useModalRegistry() {
  const context = useContext(ModalRegistryContext)
  if (!context) {
    throw new Error('useModalRegistry must be used within a ModalRegistryProvider')
  }
  return context
}
